import React, { useState } from 'react';
import { Card, Form, Button, Alert, Badge } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import TodoItem from './TodoItem';

const TodoList = ({ 
  todos = [], 
  onTodoChange, 
  onTodoDelete, 
  onTodoAdd,
  onTodoEdit,
  showSource = false,
  title = "To-Do List",
  source = "plan", // 'plan' or 'day'
  hideHeader = false
}) => {
  const { t } = useTranslation();
  const [newTodoText, setNewTodoText] = useState('');
  const [error, setError] = useState('');

  const handleAddTodo = () => {
    if (!newTodoText.trim()) {
      setError(t('planDetail.days.pleaseEnterTodo'));
      return;
    }

    const newTodo = {
      id: uuidv4(),
      text: newTodoText.trim(),
      createdAt: new Date().toISOString(),
      status: 'pending',
      source: source
    };

    onTodoAdd(newTodo);
    setNewTodoText('');
    setError('');
  };

  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTodo();
    }
  };

  return (
    <Card className="mb-3">
      {!hideHeader && (
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h5 className="m-0">
            <i className="bi bi-check2-square me-2"></i>
            {title}
          </h5>
          <Badge bg="primary" pill>
            {todos.filter(todo => todo.status === 'pending').length}/{todos.length}
          </Badge>
        </Card.Header>
      )}
      <Card.Body>
        {error && <Alert variant="danger" className="py-2">{error}</Alert>}
        
        <Form className="mb-3 d-flex">
          <Form.Control
            type="text"
            placeholder={t('planDetail.days.addNewTodo')}
            value={newTodoText}
            onChange={(e) => setNewTodoText(e.target.value)}
            onKeyDown={handleInputKeyDown}
          />
          <Button 
            variant="primary" 
            onClick={handleAddTodo}
            className="ms-2"
          >
            <i className="bi bi-plus"></i> {t('planDetail.days.add')}
          </Button>
        </Form>

        <div className="todo-list">
          {todos.length === 0 ? (
            <div className="text-center py-3 text-muted">
              <i className="bi bi-check2-all fs-4 mb-2 d-block"></i>
              <p className="mb-0">{t('planDetail.days.noTodoItems')}</p>
            </div>
          ) : (
            <>
              {/* Show pending todos first */}
              {todos
                .filter(todo => todo.status === 'pending')
                .map(todo => (
                  <TodoItem 
                    key={todo.id} 
                    todo={todo} 
                    onChange={onTodoChange} 
                    onDelete={onTodoDelete}
                    onEdit={onTodoEdit}
                    showSource={showSource}
                  />
                ))
              }
              
              {/* Then show completed todos */}
              {todos
                .filter(todo => todo.status === 'completed')
                .map(todo => (
                  <TodoItem 
                    key={todo.id} 
                    todo={todo} 
                    onChange={onTodoChange} 
                    onDelete={onTodoDelete}
                    onEdit={onTodoEdit}
                    showSource={showSource}
                  />
                ))
              }
            </>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default TodoList; 